/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ControlButton from '../../control/control-button';

/**
 * Převaděč informací o ovládání pro standardní webové technologie.
 * @implements {ControlParser}
 */
class WebControlParser {
  /** @inheritdoc */
  parseKeyCode(keyCode) {
    switch (keyCode) {
      case 13:
        return ControlButton.Enter;
      case 37:
        return ControlButton.ArrowLeft;
      case 38:
        return ControlButton.ArrowUp;
      case 39:
        return ControlButton.ArrowRight;
      case 40:
        return ControlButton.ArrowDown;
      default:
        return null;
    }
  }
}

export default WebControlParser;
